import styled from 'styled-components';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

export const RadioInput = styled.div`
  appearance: none;
  background-clip: content-box;
  border: 1px solid ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.enabledBorderSubdued};
  border-radius: 50%;
  font: inherit;
  height: 1rem;
  margin-left: auto;
  width: 1rem;

  &:active {
    background-color: ${({ theme }: { theme: BabbelTheme }): string => theme.color.accent.enabled};
    border: 1px solid ${({ theme }: { theme: BabbelTheme }): string => theme.color.accent.enabled};
    padding: 4px;
  }
`;
